// fileValidationMixin.js
export default {
  methods: {
    validateFileUrlType(url) {
      if (!url) return;

      // 1. Extract file extension (ignoring query params, etc.)
      const cleanedUrl = url.split("?")[0];
      const fileExtension = cleanedUrl.split(".").pop().toLowerCase();

      // 2. Map file extensions to MIME types
      const extensionToMime = {
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
        gif: "image/gif",

        pdf: "application/pdf",
        doc: "application/msword",
        docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        xls: "application/vnd.ms-excel",
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

        mp4: "video/mp4",
        mp3: "audio/mpeg",
        wav: "audio/wav",
      };

      const mimeType =
        extensionToMime[fileExtension] || "application/octet-stream";

      // 3. Convert this.types (assume it's defined in the component that uses this mixin)
      const typesSupported = this.types
        .split(",")
        .map((type) => type.trim().toLowerCase());

      // 4. Check if mimeType is supported
      const isSupported = typesSupported.some((type) => {
        if (type.endsWith("/*")) {
          // wildcard, e.g. "image/*" -> compare only the main segment
          const mainType = type.split("/")[0];
          const actualMain = mimeType.split("/")[0];
          return mainType === actualMain;
        } else {
          // exact MIME type check, e.g. "image/jpeg"
          return type === mimeType;
        }
      });

      if (!isSupported) {
        this.removeFile();
        throw new Error(
          `File type (${fileExtension}, ${mimeType}) is not supported. ` +
            `Supported types: ${typesSupported.join(", ")}`
        );
      }
    },
  },
};
